export default "__VITE_ASSET__1tQeTCJh__"